import {ReactNode} from 'react'
import {StyledPageHeaderContainer, StyledPageHeaderText} from '@components/commons/page-hero/style.ts'

interface PageHeaderProps {
    title: string
    subtitle?: string | null
    ctaComponent?: ReactNode
}

export const PageHero = ({title, subtitle, ctaComponent}: PageHeaderProps) => {
    return (
        <StyledPageHeaderContainer>
            <StyledPageHeaderText>
                <h1>{title}</h1>
                {subtitle && <p>{subtitle}</p>}
            </StyledPageHeaderText>
            {ctaComponent && <div>{ctaComponent}</div>}
        </StyledPageHeaderContainer>
    )
}

PageHero.displayName = 'PageHero'
